import { LinearGradient } from "react-text-gradients";
import { useEffect } from "react";
import { FaRegCalendarDays, FaLocationDot } from "react-icons/fa6";
import { AddressInfo } from "../WeddingInfo/WeddingInfo";

interface NetlfixLocationProps {
  location: AddressInfo;
  weddingDate: string;
}

const NetflixLocation: React.FC<NetlfixLocationProps> = ({
  location,
  weddingDate,
}) => {
  const clientId = "ppr0w7ahcd";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${clientId}`;
    script.async = true;
    script.onload = () => {
      const map = new window.naver.maps.Map("map", {
        center: new window.naver.maps.LatLng(location.lat, location.lon),
        zoom: 16, // 기본 zoom 값
      });

      // 기본 마커 추가 (커스텀 이미지 제거)
      new window.naver.maps.Marker({
        position: new window.naver.maps.LatLng(location.lat, location.lon),
        map,
      });
    };

    document.body.appendChild(script);
  }, []);

  // 네이버 지도에서 내 위치로 오시는 길 열기
  const handleNavigateToNaverMap = () => {
    const webUrl = location.naverAddress;
    window.open(webUrl, "_blank");
  };

  return (
    <div>
      <div className="flex items-center space-x-2 mt-12 mb-6 mx-4 ">
        <div className="text-white font-bold">오시는 길</div>
      </div>

      <div className="p-2 mx-4 bg-netflix rounded-lg font-bold">
        <div className="flex flex-col space-x-2 items-center justify-center">
          <div className="text-md text-white ">{location.address}</div>
          <div className="text-md text-white ">{location.name} pm 5시 30분</div>
          {location.address == "서울시 동대문구 망우로 61" ? (
            <div className="text-md text-white ">
              (1호선 회기역 2번출구 도보 4분거리)
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>

      <div className="mt-4">
        <div className="w-full max-w-md mt-4 flex justify-center flex-col items-center">
          {/* 지도 */}
          <div
            id="map"
            className="w-[300px] h-[300px] rounded-lg shadow-md"
          ></div>

          {/* 네이버 길찾기 버튼 */}
          <button
            onClick={handleNavigateToNaverMap}
            className="mt-6 bg-netflix text-white font-bold py-2 px-6 rounded-lg"
          >
            네이버로 길 찾기
          </button>
        </div>
      </div>
    </div>
  );
};

export default NetflixLocation;
